import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { t, huidigeTaal } from '../i18n.js';
import { versiesVoor } from '../versies.js';

/**
 * Het versienummer rechtsboven, naast het rondje van de gebruiker zoals in het klantportaal, en daarachter wat er nieuw is, **zoals in ADTS-ONE** (Versieknop daar). Een release
 * die je nergens ziet, is geen release. Hier alleen de nieuwste versie; de hele lijst staat achter *Alle wijzigingen*.
 * Een klant ziet alleen wat voor klanten is.
 */
export default function Versieknop({ klant = false, naarAlles = '/nieuw', label = false }) {
  const [open, zetOpen] = useState(false);
  const doos = useRef(null);
  const naar = useNavigate();

  useEffect(() => {
    if (!open) return undefined;
    const buiten = (e) => { if (!doos.current?.contains(e.target)) zetOpen(false); };
    const toets = (e) => { if (e.key === 'Escape') zetOpen(false); };
    document.addEventListener('mousedown', buiten);
    document.addEventListener('keydown', toets);
    return () => { document.removeEventListener('mousedown', buiten); document.removeEventListener('keydown', toets); };
  }, [open]);

  const [laatste] = versiesVoor(klant);
  const nummer = versiesVoor(false)[0].versie;
  const taal = huidigeTaal();
  return (
    <span className="versiehoek" ref={doos}>
      <button type="button" className="version-badge" aria-expanded={open} title={t('Wat er nieuw is')} onClick={(e) => { e.preventDefault(); zetOpen((v) => !v); }}>
        {label ? `${t('versie')} ${nummer}` : nummer}
      </button>
      {open && (
        <div className="ikpop versiepop">
          <span className="label">{t('Wat er nieuw is')}</span>
          {laatste && <p className="ikmeta">ADTS ZERO {laatste.versie} · {laatste.datum}</p>}
          <hr className="popstreep" />
          {laatste?.items.map((w) => <div key={w.nl} className="versierij"><span>{w[taal] ?? w.nl}</span></div>)}
          <hr className="popstreep" />
          <button type="button" className="btn" style={{ width: '100%' }} onClick={() => { zetOpen(false); naar(naarAlles); }}>{t('Alle wijzigingen')}</button>
        </div>
      )}
    </span>
  );
}
